import styled from 'styled-components'
import { themeGet } from 'styled-system'
import AccessibleTextLink from 'components/AccessibleTextLink'

export const SupportingInstructorsIconWrap = styled.span`
  display: inline-flex;

  svg {
    height: 17px;
    width: 14px;
  }
`

export const StyledAccessibleTextLink = styled(AccessibleTextLink)`
  display: inline-flex;
  align-items: center;
  color: ${themeGet('colors.white')};
  border-bottom: 1px solid ${themeGet('colors.transparent')};
  transition: border 0.2s ease;

  &:hover {
    color: ${themeGet('colors.white')};
    border-bottom: 1px solid ${themeGet('colors.white')};
    transition: border 0.2s ease;

    svg {
      color: ${themeGet('colors.white')};
    }
  }
`

export const LeaderContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  gap: 0 1.75rem;
  align-items: center;
`
